import { QuickFilterCards } from './quick-filter-cards';
import { QuickFilterDropdown } from './quick-filter-dropdown';
import { QuickFilterListItem, QuickFilterVariant, QuickFilterKey } from './types';

type Props = {
  variant?: QuickFilterVariant;
  list: QuickFilterListItem[];
  onSelect: (filter: QuickFilterKey) => void;
  onRemove?: (filter: QuickFilterKey) => void;
};

export const QuickFilters = ({ variant = 'card', list, onSelect, onRemove }: Props) => {
  if (variant === 'dropdown') {
    return <QuickFilterDropdown list={list} onSelect={onSelect} />;
  }

  return <QuickFilterCards variant={variant} list={list} onSelect={onSelect} onRemove={onRemove} />;
};
